import CONF from 'config/conf.singleton';
import PIN_STATUS from 'constants/pinStatus.const';
import { AUTH_API } from 'middleware/api';

import { CREATE_PIN_FAILURE, CREATE_PIN_REQUEST, CREATE_PIN_SUCCESS } from 'salon/constants';

const togglePin = ({ salonId, stylistId, pinStatus }) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    endpoint: `salon/v2/${salonId}/stylist/pin/${stylistId}/`,
    config: {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status: pinStatus ? PIN_STATUS.active : PIN_STATUS.inactive }),
    },
    types: [CREATE_PIN_REQUEST, CREATE_PIN_SUCCESS, CREATE_PIN_FAILURE],
  },
});

// noinspection JSUnusedGlobalSymbols
export default togglePin;
